module.exports = __webpack_public_path__ + "img/UnderConstruction-amico.55d38a00.svg";